import { DatePipe, ViewportScroller } from '@angular/common';
import { Component, EventEmitter, Inject, Output, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GlobalMessageService, TranslationService, GlobalMessageType } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { DemoRegistrationService } from 'src/app/services/feature/kb-demo-registration/demo-registration.service';
import { MyCompanyAccountService } from 'src/app/services/feature/myCompanyAccount/my-company-account.service';

@Component({
  selector: 'app-waierpopup',
  templateUrl: './waierpopup.component.html',
  styleUrl: './waierpopup.component.scss',
  standalone: false,
  providers: [DatePipe]
})
export class WaierpopupComponent {
  currentTime: string;
  isAccepted = false;
  subscription = new Subscription();
  constructor(private dialogRef: MatDialogRef<WaierpopupComponent>,
    private demoregistrationservice: DemoRegistrationService,
    private globalMessageService: GlobalMessageService,
    private viewportScroller: ViewportScroller,
    private translationService: TranslationService,
    private myCompanyAccountService: MyCompanyAccountService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,


    @Inject(MAT_DIALOG_DATA) public data: {
      emailAddress: string,
      demoCode: string,
      firstName: string,
      lastName: string,
    }) {

  }
  ngOnInit() {
    const now = new Date();
    this.currentTime = this.datePipe.transform(now, 'dd/MM/yyyy h:mm a', 'CST');


  }


  accept() {
    if (this.isAccepted) return; // extra safety
    this.isAccepted = true;
    this.cdr.detectChanges()
    this.subscription.add(this.demoregistrationservice.sendConfirmationMail(this.data.emailAddress, this.data.demoCode).subscribe((response: any) => {
      this.viewportScroller.scrollToPosition([0, 50]);
      this.dialogRef.close(response.message);
    }));
  }


  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
